import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";

export default class Contract extends Model {
    static entity = 'contract_imports';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'id',
    };

    static fields() {
        return {
            id: this.uid(),
            contract_import_id: this.attr(null),
            media_url: this.string(null),

            created_at: this.string(''),
            updated_at: this.string(''),

            contractImport: this.belongsTo(Contract, 'contract_import_id'),
        }
    }

    declare id: number;
    declare contract_import_id: number;
    declare media_url: string | null;
}
